<div class="it">
  <div class="it__toolbar">
    <app-search-input label="Search rows"
      class="it__search"
      placeholder="Search name, phone or email"
      [debounce]="200"
      (valueChange)="updateSearchTerm($event)"
    />
    <app-status-filter
      label="Show"
      [options]="filterOptions"
      [selectedValue]="filterTitle"
      allLabel="All rows"
      (selectionChange)="updateFilterOption($any($event))"
    />
  </div>

  <div class="bk-panel it__panel">
    <data-table label="Rows to check" [seamless]="true" [maxHeight]="'640px'" [skeletonColumns]="5" [resizable]="false">
      @if (pagedContacts.length) {
        <table class="bk-log">
          <thead>
            <tr>
              <th scope="col" class="num col-row">Row</th>
              <th scope="col" class="col-name">Contact</th>
              <th scope="col" class="col-phone">Phone</th>
              <th scope="col" class="col-issue">Check</th>
              <th scope="col" class="col-actions"><span class="bk-sr-only">Actions</span></th>
            </tr>
          </thead>
          <tbody>
            @for (contact of pagedContacts; track rowKey(contact, $index)) {
              <tr
                class="is-link"
                tabindex="0"
                (click)="openContactDetail(contact)"
                (keydown.enter)="openFromKeyboard($event, contact)"
              >
                <td class="num quiet col-row">{{ rowNumber(contact) ?? '—' }}</td>
                <td class="col-name">
                  <span class="bk-msg">
                    <span class="bk-msg__subject">{{ name(contact) }}</span>
                    <span class="bk-msg__preview">{{ contact.personEntity.emailAddress || 'No email' }}</span>
                  </span>
                </td>
                <td class="quiet col-phone">{{ contact.personEntity.primaryContactNumber || '—' }}</td>
                <td class="col-issue">
                  @if (contact.batchLineValidationStatus === 'PROCESSING_ERROR') {
                    <ul class="it__issues">
                      @for (issue of issues(contact); track $index) {
                        <li>
                          @if ($first) {
                            <app-status [text]="issueText(issue)" status="failed" />
                          } @else {
                            <span class="it__issue-more">{{ issueText(issue) }}</span>
                          }
                        </li>
                      }
                    </ul>
                  } @else {
                    <app-status text="Ready" status="success" />
                  }
                </td>
                <td class="col-actions">
                  <span class="bk-row-actions">
                    <button
                      type="button"
                      class="bk-icon-btn"
                      [attr.aria-label]="'Fix ' + name(contact)"
                      matTooltip="Edit row"
                      (click)="$event.stopPropagation(); openEditContact(contact)"
                    >
                      <span class="bk-sym" aria-hidden="true">edit</span>
                    </button>
                    <button
                      type="button"
                      class="bk-icon-btn it__danger"
                      [attr.aria-label]="'Remove ' + name(contact) + ' from this import'"
                      matTooltip="Remove row"
                      (click)="$event.stopPropagation(); openDeletePrompt(contact)"
                    >
                      <span class="bk-sym" aria-hidden="true">delete</span>
                    </button>
                  </span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <app-empty-state
          icon="contacts"
          [message]="totalCount ? 'No rows here' : 'No rows left in this import'"
          [query]="searchTerm"
          [filtered]="filterTitle !== 'All'"
          size="medium"
          (clear)="clearSearchAndFilter()"
        />
      }
    </data-table>
  </div>

  @if (filteredContacts.length > pageSize) {
    <div class="it__pager">
      <app-pagination
        [totalPages]="totalPages"
        [currentPage]="currentPage"
        [totalItems]="filteredContacts.length"
        [pageSize]="pageSize"
        (changePage)="goToPage($event)"
        (onNext)="nextPage()"
        (onPrev)="prevPage()"
        (pageSizeChange)="changePageSize($event)"
      />
    </div>
  }

  <!-- MODALS -->
  @if (showContactDetail) {
    <contact-detail
      (closeModal)="closeContactDetail()"
      [contact]="selectedContact?.personEntity ?? null"
      [isLocalContacts]="true"
    />
  }

  @if (openEditContactModal) {
    <edit-uploaded-contact
      [index]="selectedContactIndex!"
      [selectedContact]="selectedContact?.personEntity ?? null"
      [issues]="selectedContact?.constraintViolations ?? []"
      (closeModalEvent)="closeEditContact()"
    />
  }

  <app-prompt-card
    buttonText="Remove row"
    title="Remove this row?"
    tone="danger"
    [openModal]="showDeletePrompt"
    (onClose)="closeDeletePrompt()"
    (onButtonClick)="deleteContact()"
  >
    <p class="it__prompt">
      <strong>{{ selectedContact ? name(selectedContact) : 'This row' }}</strong> will be left out of this import.
      Your file is not changed.
    </p>
  </app-prompt-card>
</div>
